import React, { useState } from 'react';
import { Table, TimestampFilters } from 'dyl-components';
import { Table as SemanticTable, Icon } from 'semantic-ui-react';
import { useSearchParams, useNavigate, useParams } from 'react-router-dom';
import {
    getData,
    onToggleTimeUnit,
    useRangeCalendar,
} from 'shared/CustomDateRange/customDateRange';

const SortActions = ({ direction = false, onToggleSort = () => { } }) => {
    return (
        <div
            onClick={onToggleSort}
            style={{ display: "inline-flex", cursor: "pointer" }}
        >
            <Icon
                name="fa-solid fa-arrow-down-long"
                style={{
                    marginRight: -7,
                    opacity: !direction ? "100%" : "50%",
                }}
            />
            <Icon
                name="fa-solid fa-arrow-up-long"
                style={{ opacity: direction ? "100%" : "50%" }}
            />
        </div>
    );
};

const SessionTableHeader = () => {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const { id } = useParams();

    const {
        timestamp,
        setTimestamp,
        isCustomDateRangeOpen,
        setCustomDateRangeOpen,
        userAuthTimezone,
        dateRange,
        setDateRange,
    } = useRangeCalendar(params);

    const onDateRangeChange = (_, { value }) => {
        setDateRange(value);
    };

    const isAscending = params.get("order") === "asc";
    const url = `/campaigns/${id}/session-summary`;

    const onToggleSort = () => {
        const query = new URLSearchParams(params);
        const order = !isAscending ? "asc" : "desc";
        query.set("order", order);
        const query_string = query.toString();
        navigate(`${url}${query_string ? `?${query_string}` : ""}`);
    }

    const [isTimeRangeOpen, setTimeRangeOpen] = useState(false);

    return (
        <Table.Row>
            <SemanticTable.HeaderCell width={1} />
            <SemanticTable.HeaderCell width={2}>
                <span style={{ marginRight: 5 }}>Text Session</span>
                <TimestampFilters
                    timestamp={timestamp}
                    onToggleTimeUnit={(timestamp) =>
                        onToggleTimeUnit(
                            timestamp,
                            setTimestamp,
                            params,
                            navigate,
                            url
                        )
                    }
                    areTimeUnitOptionsOpen={isTimeRangeOpen}
                    onOpenTimeUnitOptions={() => setTimeRangeOpen(true)}
                    onCloseTimeUnitOptions={() => setTimeRangeOpen(false)}
                    isCustomDateRangeOpen={isCustomDateRangeOpen}
                    onOpenCustomDateRange={() => { setCustomDateRangeOpen(true); setDateRange("") }}
                    onCloseCustomDateRange={() => setCustomDateRangeOpen(false)}
                    dateRange={dateRange}
                    onDateRangeChange={onDateRangeChange}
                    getData={() =>
                        getData({
                            setCustomDateRangeOpen,
                            dateRange,
                            userAuthTimezone,
                            params,
                            navigate,
                            url,
                        })
                    }
                />
                <SortActions
                    direction={isAscending}
                    onToggleSort={onToggleSort}
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={1}>Texts Sent</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={1}>Campaign Status</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={4}>Message</SemanticTable.HeaderCell>
        </Table.Row>
    );
};

export default SessionTableHeader;
